/**
 * Validates password complexity requirements
 * @param {string} password - The password to validate
 * @returns {string|null} - Error message if validation fails, null if valid
 */
export const validatePasswordComplexity = (password) => {
  if (!password) {
    return 'Password is required'
  }

  if (password.length < 12) {
    return 'Password must be at least 12 characters long'
  }

  const hasUppercase = /\p{Lu}/u.test(password)
  const hasLowercase = /\p{Ll}/u.test(password)
  const hasDigit = /\p{Nd}/u.test(password)
  // Aligned with backend: any Unicode punctuation or symbol counts as a special character.
  const hasSpecial = /[\p{P}\p{S}]/u.test(password)

  const missing = []
  if (!hasUppercase) missing.push('uppercase letter')
  if (!hasLowercase) missing.push('lowercase letter')
  if (!hasDigit) missing.push('digit')
  if (!hasSpecial) missing.push('special character')

  if (missing.length > 0) {
    return `Password must contain at least one: ${missing.join(', ')}`
  }

  return null
}

/**
 * Gets password requirements as a human-readable string
 * @returns {string} - Password requirements
 */
export const getPasswordRequirements = () => {
  return 'Password must be at least 12 characters and contain uppercase, lowercase, digit, and special character'
}
